module.exports = __webpack_public_path__ + "img/PL08260.b23b1ce8.png";